import React, { useEffect, useRef } from 'react';
import { track, EVENTS } from '../../services/analytics';
import { POPULAR } from '../../content/astraPopular';

/**
 * "Students are asking" (#5258; founder pick A of the #5243 mocks): up to
 * three questions in the student's voice for the topics asked most, under
 * her own next-step chips on signed-in Astra's opening. The rank is the
 * server's (counselor_agent/astra_popular.py); the words are
 * content/astraPopular.js's studentShelf. A chip sends its words as her turn
 * through the same path as a next-step chip. While the shelf reads the
 * visitors' week it says so under it.
 */
export default function PopularShelf({ shelf, onAsk, busy = false }) {
    const shownRef = useRef(false);
    useEffect(() => {
        if (!shelf || shownRef.current) return;
        shownRef.current = true;
        track(EVENTS.ASTRA_POPULAR_SHOWN, { surface: 'astra', basis: shelf.basisLine ? 'week' : 'students', n: shelf.chips.length });
    }, [shelf]);
    if (!shelf) return null;
    const tap = (c) => {
        track(EVENTS.ASTRA_POPULAR_TAPPED, { surface: 'astra', topic: c.topic, rank: c.rank });
        onAsk(c.label);
    };
    return (
        <div role="group" aria-label={POPULAR.studentLabel} data-testid="astra-popular-shelf"
             className="mx-auto w-full max-w-md pt-3 text-left">
            <p aria-hidden="true" className="mb-1.5 text-[11px] font-semibold uppercase tracking-[0.07em] text-[#6B6B6B]">
                {POPULAR.studentLabel}
            </p>
            <div className="space-y-1.5">
                {shelf.chips.map((c) => (
                    <button key={c.topic} type="button" onClick={() => tap(c)} disabled={busy}
                            data-testid="astra-popular-shelf-chip" data-topic={c.topic}
                            className="flex min-h-[44px] w-full items-center rounded-xl border border-[#E0DED8] bg-white px-3.5 py-2 text-left text-[13px] font-semibold leading-snug text-[#3C463E] hover:bg-[#F8F6F0] disabled:opacity-60">
                        {c.label}
                    </button>
                ))}
            </div>
            {shelf.basisLine && (
                <p data-testid="astra-popular-basis" className="mt-2 text-[12.5px] leading-snug text-[#3C463E]">
                    {shelf.basisLine}
                </p>
            )}
        </div>
    );
}
